import React, { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './UserProfileNavbar.less';

export const UserProfileNavbar: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const sections = [
    {
      id: 1,
      path: 'info',
      section_name: 'Личные и контактные данные',
    },
    {
      id: 2,
      path: 'subscriptions',
      section_name: 'Подписка на просьбы',
    },
    {
      id: 3,
      path: 'change-password',
      section_name: 'Смена пароля',
    },
  ];

  const menu = (
    <div className="user-profile-navbar-menu">
      {sections.map((el) => {
        const path = `/profile/${el.path}`;
        const onClick = () => {
          navigate(path);
          window.scrollTo(0, 0);
        };
        return (
          <div
            key={el.id}
            onClick={onClick}
            className="user-profile-navbar-menu-item"
            style={
              path === location.pathname
                ? {
                    backgroundColor: '#315373',
                    color: 'white',
                  }
                : {}
            }
          >
            {el.section_name}
          </div>
        );
      })}
    </div>
  );
  return <div className="user-profile-navbar">{menu}</div>;
};
